/**
 * تحميل وحدة اختياريّة (تتبّع · قياس · بكسلات) دون إسقاط تجربة الزائر.
 *
 * السبب الجذريّ: `import("...").then(({ x }) => x())` يرمي رفضاً غير مُعالَج
 * إن فشل تحميل الـchunk (شبكة مقطوعة، متصفّح داخل تطبيق، زاحف يوقف الطلب)
 * فتصل أخطاء مثل: `Cannot destructure property 'initPerfTracker' of 'undefined'`.
 *
 * القاعدة: لا يُسقط قياسٌ صفحةً. مرّر كلّ تحميل اختياريّ عبر `quiet()`.
 */
export function quiet(work: Promise<unknown>): void {
  void work.catch(() => {
    /* وحدة اختياريّة: الفشل لا يُبلَّغ ولا يكسر الصفحة */
  });
}
